import React, { useEffect, useMemo, useRef } from 'react';
import { translate } from '../../Services/translation';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getOrder } from '../../Actions/Order.action';
import Icon from '../Icon';
import OrderDetail from '../OrderDetail/OrderDetail';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { reorder } from '../../Services/Cart.service';
import { receive, loadError } from '../../Actions/Cart.action';
import { catchError } from '../../Actions/Error.action';
import { setError } from '../../Actions/Order.action';
import { useReactToPrint } from 'react-to-print';

const MyPagesOrderDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { order, errors = {} } = useTypedSelector(
    (state) => state.myPage.orders
  );
  const generalError = useMemo(
    () =>
      errors && errors['general']?.length ? errors['general'][0] : null,
    [errors]
  );

  useEffect(() => {
    if (!order) {
      dispatch(getOrder(id));
    }
  }, []);

  const addOrderToCart = async () => {
    try {
      const cart = await reorder(id);
      dispatch(receive(cart));
      return true;
    } catch (ex) {
      dispatch(catchError(ex, (error) => loadError(error)));
      return false;
    }
  };

  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="col-span-3">
      <div className="mb-4 flex flex-col gap-2 md:flex-row md:justify-between md:gap-0 lg:mb-6">
        <button
          className="btn btn--small btn--outline w-full md:w-fit"
          onClick={() => {
            dispatch(setError({ general: [] }));
            navigate(-1);
          }}
        >
          <Icon name="chevron-left" className="order-icon" />
          {translate('mypage.order.allorders')}
        </button>
        <div className="flex gap-2 md:gap-6">
          <button
            className="btn btn--outline btn--small flex w-1/2 items-center justify-center md:w-fit"
            onClick={addOrderToCart}
          >
            <Icon name="refresh" className="order-icon" />
            {translate('mypage.order.addtocart')}
          </button>
          <button
            className="btn btn--small btn--outline w-1/2 items-center justify-center md:w-fit"
            onClick={handlePrint}
          >
            <Icon name="print" className="mr-2 h-4 w-4" />
            {translate('mypage.order.print')}
          </button>
        </div>
      </div>
      {generalError && (
        <p className="error color-error-500 text-md">{generalError}</p>
      )}
      {order ? (
        <OrderDetail
          ref={componentRef}
          order={order}
          isConfirmation={false}
        />
      ) : null}
    </div>
  );
};

export default MyPagesOrderDetail;
